// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import App from './app'

import Metronic from './index'

import router from './router'
import store from './store'

import ElementUI from 'element-ui'
// import lang from 'element-ui/lib/locale/lang/en'
// import locale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'

// 设置语言
// locale.use(lang)

Vue.use(ElementUI, { size: 'small', zIndex: 3000 });

// import './mock'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

Vue.use(Metronic)



// WEBPACK FOOTER //
// ./src/main.js